export default "__VITE_ASSET__afbb725d__"